import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';


@Component({
    selector: 'app-change-password-failed',
    templateUrl: './change-password-failed.component.html',
    standalone: false
})
export class ChangePasswordFailedComponent implements OnInit {

  constructor(public translate: TranslateService) { }

  ngOnInit(): void { }

}
